import AccordionTableDetails from './AccordionTableDetails'

export default AccordionTableDetails
